module.exports = __webpack_public_path__ + "static/media/question-circle-solid.4485f886.svg";